import { isMobile } from 'react-device-detect';
import { Redirect, Route } from 'react-router-dom';
import { PATH } from 'routes/constant';
import utils from 'utils/utils';

export default function DesktopRoute({ component: Component, ...rest }) {
    const mobile = JSON.parse(sessionStorage.getItem('isMobile') || JSON.stringify(isMobile));
    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;
                return (mobile || utils.isAppInWidgetMode()) ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: PATH.INTRO,
                            state: { from: location },
                        }}
                    />
                );
            }}
        ></Route>
    );
}
